<template>
    <div
            ref="node"
            :style="nodeContainerStyle"
            @click="clickNode"
            @mouseup="changeNodeSite"
            :class="nodeContainerClass"
    >
        <!-- 最左侧的那条竖线 -->
        <div class="ef-node-left"></div>
        <!-- 节点类型的图标 -->
        <div class="ef-node-left-ico flow-node-drag">
            <i :class="nodeIcoClass"></i>
        </div>
        <!-- 节点名称 -->
        <!--<div class="ef-node-text" :show-overflow-tooltip="true">
            {{node.name}}
        </div>-->
        <el-popover
          placement="top-start"
          title="内容"
          width="200"
          trigger="hover"
          v-if="node.content!=null || node.contentTrans!=null"
          style="margin-left: -5px"
        >
          <template>
            <div v-if="internationalVersionFlag == 1 && languageSelect === '0'" class="node_content">{{ node.contentTrans || node.content }}</div>
            <div v-else-if="internationalVersionFlag == 1" class="node_content">{{ node.content || node.contentTrans }}</div>
            <div v-else class="node_content">{{ node.content }}</div>
          </template>
          <div slot="reference" class="ef-node-text" :show-overflow-tooltip="true">
            {{node.name}}
          </div>
        </el-popover>
        <div v-else slot="reference" class="ef-node-text" :show-overflow-tooltip="true">
          {{node.name}}
        </div>
        <div v-if="node.filePath !== null && node.filePath !== '' && node.filePath !== undefined" id="audio">
<!--          <el-button slot="reference" :icon="isPlay==false?'el-icon-video-play':'el-icon-video-pause'" @click="autoPlay" circle style="font-size: 20px;"></el-button>-->
          <i slot="reference" :style="isPlay==false?'':'color: red;'" :class="isPlay==false?'el-icon-video-play':'el-icon-video-pause'" @click="autoPlay" style="cursor: pointer;margin-right: 26px;margin-top: 3px;font-size: 25px"></i>
        </div>

        <!-- 节点状态图标 -->
        <div class="ef-node-right-ico" style="margin-right: -6px">
            <i class="el-icon-circle-check el-node-state-success" v-show="node.state === 'success'"></i>
            <i class="el-icon-circle-close el-node-state-error" v-show="node.state === 'error'"></i>
            <i class="el-icon-warning-outline el-node-state-warning" v-show="node.state === 'warning'"></i>
            <i class="el-icon-loading el-node-state-running" v-show="node.state === 'running'"></i>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    node: Object,
    activeElement: Object
  },
  data() {
    return {
      isPlay: false,
      myAuto: new Audio(this.node.filePath),
      catchLanguageSelect: this.$getLanguageSelect()
    };
  },
  computed: {
    internationalVersionFlag() {
      return this.$getInternationalVersionFlag();
    },
    languageSelect() {
      return this.catchLanguageSelect;
    },
    nodeContainerClass() {
      return {
        'ef-node-container': true,
        'ef-node-active': this.activeElement.type === 'node' ? this.activeElement.nodeId === this.node.id : false
      };
    },
    // 节点容器样式
    nodeContainerStyle() {
      return {
        top: this.node.top,
        left: this.node.left
      };
    },
    nodeIcoClass() {
      const nodeIcoClass = {};
      nodeIcoClass[this.node.ico] = true;
      // 添加该class可以推拽连线出来，viewOnly 可以控制节点是否运行编辑
      nodeIcoClass['flow-node-drag'] = !this.node.viewOnly;
      return nodeIcoClass;
    }
  },
  mounted() {
    this.langChangeHandler = (newLang) => {
      this.catchLanguageSelect = newLang;
    };
    this.$bus.$on('languageSelectChanged', this.langChangeHandler);
  },
  beforeDestroy() {
    this.$bus.$off('languageSelectChanged', this.langChangeHandler);
  },
  methods: {
    autoPlay() {
      this.isPlay = !this.isPlay;
      if (this.isPlay) {
        this.myAuto.play();
        this.palyEnd();
      } else {
        this.myAuto.pause();
        this.palyEnd();
      }
    },
    palyEnd() {
      this.myAuto.addEventListener('ended', () => {
        this.isPlay = false;
      });
    },
    // 点击节点
    clickNode() {
      this.$emit('clickNode', this.node.id);
    },
    // 鼠标移动后抬起
    changeNodeSite() {
      // 避免抖动
      if (this.node.left === this.$refs.node.style.left && this.node.top === this.$refs.node.style.top) {
        return;
      }
      this.$emit('changeNodeSite', {
        nodeId: this.node.id,
        left: this.$refs.node.style.left,
        top: this.$refs.node.style.top
      });
    }
  }
};
</script>
<style scoped>
.node_content {
  height: 100px;
  overflow-y: scroll;
}
/*滚动条样式*/
.node_content::-webkit-scrollbar{
  width: 4px;
  height: 9px;
}
.node_content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.2);
}
.node_content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 0;
  background: rgba(0,0,0,0.1);

}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/ef/node.vue